//#region src/shared/types.ts
const consentTypes = {
	HIPAA: "hipaa",
	TCPA: "TCPA",
	MARKETING: "marketing"
};
const consentStatuses = {
	ACTIVE: "accepted",
	DECLINED: "declined",
	REVOKED: "revoked"
};

//#endregion
export { consentStatuses, consentTypes };